import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AppLoadingService {
  public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  display(value: boolean) {
    if (value === false) {
      setTimeout(() => {
        this.status.next(value);
      }, 500);
    } else {
      this.status.next(value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/common/loading.service.ts